import axios from "axios";

export function apiErrorMessage(error: unknown, fallback: string) {
  if (!axios.isAxiosError(error)) return fallback;
  const payload = error.response?.data;
  if (typeof payload === "string") {
    const message = payload.trim();
    return message.startsWith("<") || message.toLowerCase().includes("<!doctype")
      ? fallback
      : message;
  }
  if (payload && typeof payload === "object") {
    const detail = (payload as { detail?: unknown }).detail;
    if (typeof detail === "string") return detail;
    const firstValue = Object.values(payload).find((value) => value != null);
    if (typeof firstValue === "string") return firstValue;
    if (Array.isArray(firstValue) && typeof firstValue[0] === "string") {
      return firstValue[0];
    }
  }
  return fallback;
}

export function hasUncertainApiOutcome(error: unknown) {
  if (!axios.isAxiosError(error)) return true;
  return !error.response || error.response.status >= 500;
}
